// ResizeHandle.js
import React from 'react';
import { PanelResizeHandle } from "react-resizable-panels";
import styles from "./styles.module.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const ResizeHandle = React.forwardRef(({ className = "", id, iconName }, ref) => {
  return (
    <PanelResizeHandle
      ref={ref}
      className={[styles.ResizeHandleOuter, className].join(" ")}
      id={id}
    >
      <div
        className={styles.ResizeHandleInner}
        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <i className={iconName} style={{ position: "absolute" }}></i>
      </div>
    </PanelResizeHandle>
  );
});

export default ResizeHandle;
